<template>
  <div class="invoice-history">
    <fixed-header title="开票历史"></fixed-header>
    <div v-infinite-scroll="loadMore" :infinite-scroll-disabled="loading"
         :infinite-scroll-distance="30"
         class="invoice-history__main scroll-touch">
      <!--            <div v-if="showEmpty" class="invoice-history__empty">-->
      <!--                <i :class="['icon', 'invoice_empty']"></i>-->
      <!--                <p>暂无更多记录哦~</p>-->
      <!--            </div>-->
      <div v-for="(item, index) in historyList" :key="index" class="invoice-history__box-wrap">
        <div class="invoice-history__box">
          <div class="invoice-history__box-info" @click="gotoInvoiceDetail(item.invoiceId)">
            <div class="invoice-history__box-time">
              <i :class="['icon', 'invoice_time']"></i>
              <span>{{ item.invoiceApplySn }}</span>
              <i :class="['icon', 'invoice_arrow_trans']"></i>
            </div>
            <div class="invoice-history__box-intro">
              <span class="invoice-history__box-intro-type">电子发票</span>
              <span class="invoice-history__box-intro-amount">{{ item.invoiceMoney }}</span>
              <span class="invoice-history__box-intro-unit">元</span>
            </div>
          </div>
          <div class="invoice-history__box-status">
            <span
                class="invoice-history__box-status-tag">{{
                endowValue(invoiceStatus, getInvoiceStatus(item.review, item.status))
              }}</span>
            <span v-if="item.status === 1" class="invoice-history__box-status-button"
                  @click="gotoInvoiceAgain(item.invoiceApplySn)">重发发票</span>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
import * as invoiceApis from 'apis/invoice';
import { getMgtvUserTicket, setAsyncUserInfo } from 'utils/user';

export default {
  name: 'index',
  components: {
    FixedHeader,
  },
  data() {
    return {
      p: 0,
      loading: false, // false执行loadMore
      disableLoad: false,
      historyList: [],
      showEmpty: true,
      reviewType: [
        { value: 0, label: '待审核' },
        { value: 1, label: '审核通过' },
        { value: 2, label: '审核不通过' },
      ],
      statusType: [
        { value: 0, label: '待开' },
        { value: 1, label: '已开' },
        { value: 2, label: '已作废' },
      ],
      invoiceStatus: [
        { value: 0, label: '待审核' },
        { value: 1, label: '审核通过/待开' },
        { value: 2, label: '已开票' },
        { value: 3, label: '审核不通过' },
      ],
    };
  },
  methods: {
    getInvoiceStatus(scope1, scope2) {
      if (scope1 === 0) {
        return 0;
      } else if (scope1 === 1) {
        if (scope2 === 0) {
          return 1;
        } else if (scope2 === 1) {
          return 2;
        }
        return 4;
      }
      return 3;
    },
    endowValue(arr, scope) {
      if (arr && arr.length) {
        const e = arr.find(v => v.value === scope);
        if (e) {
          return e.label;
        }
        return '';
      }
      return '';
    },
    toast(message) {
      this.$toast({
        message,
        duration: 1000,
      });
    },
    gotoInvoiceDetail(id) {
      MgStat.send('click', {}, {
        mod: 'history',
        cont: '点击开票历史',
        direct: 'cntp',
        label: 'btn',
        cntp: 'haowu_invoiceHistory',
      });
      this.$router.push({ path: '/invoice/history/detail', query: { id } });
    },
    gotoInvoiceAgain(invoiceApplySn) {
      MgStat.send('click', {}, {
        mod: 'reset_invoice',
        cont: '点击重发发票',
        direct: 'cntp',
        label: 'btn',
        cntp: 'haowu_invoiceHistory',
      });
      this.$router.push({ path: '/invoice/history/again', query: { invoiceApplySn } });
    },
    /* 页面初始化会自动执行一次 */
    async loadMore() {
      if (this.disableLoad) {
        return;
      }
      if (this.loading) {
        return;
      }
      this.p += 1;
      const userInfo = getMgtvUserTicket();
      if (!(userInfo && userInfo.ticket)) {
        await setAsyncUserInfo();
      }
      this.invoiceHistoryList();
      this.initShowEmpty();
    },
    async invoiceHistoryList() {
      try {
        this.loading = true;
        const data = await invoiceApis.invoiceHistoryList(this.p);
        if (data) {
          this.loading = false;
          this.historyList.push(...(data.list));
          if (!(data.list).length) {
            this.disableLoad = true;
          }
        }
      } catch (error) {
        const { message } = error;
        this.$toast(`获取开票记录失败:${message}`);
      }
    },
    async initShowEmpty() {
      if (this.historyList.length === 0) {
        this.showEmpty = true;
      } else {
        this.showEmpty = false;
      }
    },
  },
};
</script>

<style lang="scss">

.invoice-history {
  height: 100%;
  box-sizing: border-box;

  &__empty {
    margin-top: 210px;
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      margin-top: 12px;
      font-size: 28px;
      color: #a8a8a8;
    }
  }

  &__main {
    height: 100%;
  }

  &__box-wrap {
    margin: 20px 24px;
    background: #FFFFFF;
    border-radius: 10px;
    min-height: 240px;
  }

  &__box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    &-info {
      width: 100%;
      height: 150px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    }


    &-time {
      display: flex;
      padding: 30px 10px 0 20px;
      flex-direction: row;
      position: relative;
      /*justify-content: center;*/
      align-items: center;

      span {
        padding-left: 6px;
        font-size: 24px;
        color: #585858;
        height: 33px;
        line-height: 33px;
        width: 612px;
      }
    }

    &-intro {
      display: flex;
      padding: 0 20px 0 20px;
      position: relative;
      height: 80px;
      /*align-items: center;*/

      &-type {
        margin-top: 24px;
        width: 112px;
        height: 40px;
        color: #585858;
        font-size: 28px;
      }

      &-amount {
        text-align: right;
        margin-left: 370px;
        margin-top: 20px;
        width: 146px;
        height: 53px;
        color: #323232;
        font-size: 38px;
      }

      &-unit {
        margin-left: 10px;
        margin-top: 27px;
        width: 24px;
        height: 33px;
        color: #585858;
        font-size: 24px;
      }
    }

    &-status {
      display: flex;
      width: 100%;
      height: 90px;
      align-items: center;

      &-tag {
        height: 40px;
        width: 500px;
        margin-left: 20px;
        font-size: 28px;
        color: #BABABA;
      }

      &-button {
        height: 50px;
        width: 160px;
        border-radius: 10px;
        border: 1px solid rgba(255, 95, 0, 1);
        font-size: 24px;
        color: #FF5F00;
        display: flex;
        align-items: center;
        justify-content: center;
      }

    }

  }
}

</style>
